export const attractionsData = {
  attractionsLinks: {
    title: "Odkazy na zajímavosti",
    linksToDetails: [
      { label: "Město Hlučín", path: "https://www.hlucin.cz/", },
      { label: "Sport a kultura Hlučín", path: "https://www.sak-hlucin.cz/cs/", },
      { label: "Turistické informační centrum Hlučín", path: "https://www.ic-hlucin.cz/cs/", },
      { label: "Muzeum Hlučínska", path: "https://www.muzeum-hlucinska.cz/", },
      { label: "Sdružení obcí Hlučínska", path: "https://www.hlucinsko.eu/", },
      { label: "Opavské Slezsko", path: "https://opavske-slezsko.cz/", },
      { label: "Slezské zemské muzeum", path: "https://www.szm.cz/", },
      { label: "Technotrasa", path: "https://technotrasa.cz/", },
      { label: "Silesianka - stezka rozhleden Euroregionu", path: "https://silesianka.eu/"}
    ]
  },
  attractions: {
    title: "Zajímavostí",
  }
};